import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router, ActivatedRoute } from '@angular/router';
import { OpenDialogChooseImageFromClubComponent } from 'app/components/dialog/open-dialog-choose-image-from-club/open-dialog-choose-image-from-club.component';
import { OpenDialogDuplicateOfferComponent } from 'app/components/dialog/open-dialog-duplicate-offer/open-dialog-duplicate-offer.component';
import { OpenDialogGoToOfferSessionComponent } from 'app/components/dialog/open-dialog-go-to-offer-session/open-dialog-go-to-offer-session.component';
import { OpenDialogImportImageComponent } from 'app/components/dialog/open-dialog-import-image/open-dialog-import-image.component';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { OfferSession } from 'app/shared/models/class/session/session';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { OfferService } from 'app/shared/services/offer/offer.service';
import { TooltipService } from 'app/shared/services/tooltip/tooltip.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';
import { environment } from 'environments/environment';

const reader = new FileReader();

@Component({
  selector: 'app-admin-offers-table',
  templateUrl: './admin-offers-table.component.html',
  styleUrls: ['./admin-offers-table.component.scss']
})
export class AdminOffersTableComponent extends SubscriptionBaseComponent implements OnInit {
  @Input() offers: FullOffer[];

  @Output() onEdit = new EventEmitter<FullOffer>();
  @Output() offerPreviewUpdate = new EventEmitter<FullOffer>();
  @Output() switchToSession = new EventEmitter<FullOffer>();
  @Output() switchToFiles = new EventEmitter<FullOffer>();
  @Output() imageUpdate = new EventEmitter<any>();
  @Output() refreshOffers = new EventEmitter<boolean>();

  displayedColumns: string[] = ['offerKey', 'offreNom', 'clubNom', 'price', 'backoffice', 'session', 'file', 'preview', 'editImage', 'edit', 'duplicate', 'link', 'isActive', 'rating'];
  dataSource: MatTableDataSource<FullOffer>;

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  length: number;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  pageEvent: PageEvent;
  color: ThemePalette = 'primary';
  offer: FullOffer = null;

  testFORM: UntypedFormGroup;
  offerKey: string;
  isLoading = false;
  isLoadingZipAllOffers = false;
  isLoadingZipOneOffer = false;

  constructor(
    private dataService: DataService,
    private offerService: OfferService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
    private uiService: UiService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private tooltip: TooltipService,
    private faIconService: FaiconService,

  ) {
    super()
  }

  ngOnInit(): void {
    this.initSub();

    this.initTable();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  private initSub(): void {
    this.subscription
      .add(
        this.dataService.valueInputSearchOfferAdminTable.subscribe({
          next: valueInputSearchOfferAdminTable => {
            this.applyFilter(valueInputSearchOfferAdminTable);
            this.cdr.detectChanges();
          }
        })
      );
  }

  private initTable(): void {
    this.isLoading = true;

    this.dataSource = new MatTableDataSource<FullOffer>(this.offers);
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'offreNom': return item.offerName;
        case 'clubNom': return item.clubCode;
        case 'price': return item.price;
        case 'isActive': return item.isActive;
        default: return item[property];
      }
    };

    this.length = this.offers?.length;
    this.isLoading = false;
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }


  changePreview(offer: FullOffer): void {
    this.offerPreviewUpdate.next(offer);
    this.cdr.detectChanges();
  }

  editOffer(offer: FullOffer, tab?: string, action?: string): void {
    this.offerPreviewUpdate.emit(offer);
    this.onEdit.emit(offer);
  }

  isActivatedOrDeactivated(offer: FullOffer): void {
    const newIsActive = !offer.isActive;

    if (!offer.isActive) {

      if (!offer.picture) {
        this.uiService.showSnackbar(`L'offre n'a pas de photo.`);
        this.refreshOffers.next(true);
        return;
      }

      if (!offer.sessions && !offer.isExternalOffer && offer?.hasSession) {
        const dialogRef = this.dialog.open(OpenDialogGoToOfferSessionComponent);

        dialogRef.afterClosed().subscribe({
          next: () => this.addSession(offer)
        });

        return;
      }
      const { picture, sessions, isExternalOffer, hasSession } = offer;
      const check1 = picture && sessions?.length && !isExternalOffer && hasSession;
      const check2 = picture && !isExternalOffer && !hasSession;
      const check3 = picture && isExternalOffer;


      if (check1 || check2 || check3) {
        this.offerService.activateOrDeactivateOffer(offer.offerKey, newIsActive).subscribe({
          next: () => { }
        });
      }
    } else {
      this.offerService.activateOrDeactivateOffer(offer.offerKey, newIsActive).subscribe({
        next: () => { }
      });
    }
  }

  duplicateOffer(offer: FullOffer): void {
    const dialogRef = this.dialog.open(OpenDialogDuplicateOfferComponent, {
      data: { offer: offer }
    });

    dialogRef.afterClosed().subscribe({
      next: (res) => {
        if (res?.hasSession) {
          const dialogRef2 = this.dialog.open(OpenDialogGoToOfferSessionComponent);

          dialogRef2.afterClosed().subscribe({
            next: () => this.addSession(res)
          });

          return;
        } else {
          this.refreshOffers.next(true);
        }
      }
    });
  }

  getTooltip(tooltip: string): string {
    return this.tooltip.getTooltip(tooltip);
  }

  addSession(offer: FullOffer): void {
    this.switchToSession.next(offer);
  }

  copyString(offerKey: number): void {
    const link = `${environment.urlSite}home/offer?offerKey=${offerKey}`;
    if (navigator.clipboard) { navigator.clipboard.writeText(link); }
  }

  goToFilesOffer(offer: FullOffer): void {
    this.changePreview(offer);
    this.switchToFiles.next(offer);
  }

  getLengthSession(sessions: OfferSession[]): OfferSession[] {
    return sessions.filter(s => s.sessionStartDate.toString() !== '0001-01-01T00:00:00Z');
  }

  downloadImagesFromOneOffer(offer: FullOffer) {
    this.isLoadingZipOneOffer = true;
    this.offerService.getOfferPicturesZip(offer.offerKey).subscribe(() => {
      this.isLoadingZipOneOffer = false;
    }, (error) => {
      console.error('error', error)
      this.isLoadingZipOneOffer = false;
    })
  }

  downloadAllMainPicturesFromOffers() {
    this.isLoadingZipAllOffers = true;
    this.offerService.getOfferMainPicturesZip().subscribe(() => {
      this.isLoadingZipAllOffers = false;
    }, (error) => {
      console.error('error', error)
      this.isLoadingZipAllOffers = false;
    })
  }

  openDialogChooseImageFromClub(offer: FullOffer) {
    let clubCode = offer.clubCode;

    const dialogRef = this.dialog.open(OpenDialogChooseImageFromClubComponent, {
      data: { clubCode: clubCode },
      height: '85%',
      width: '80%'
    });

    dialogRef.afterClosed().subscribe({
      next: (res) => {
        if (res) {
          this.convertImageToFile(res, offer.offerKey);
        }
      }
    });
  }

  convertImageToFile(offerKey: number, offerKeyToSet: number) {
    this.offerService.getImgOffer(offerKey).subscribe({
      next: image => {
        let file = this.dataURLtoFile(`data:image/png;base64, ${image.pictureBase64}`, `image_${offerKey}`);
        reader.readAsDataURL(file),
          reader.onload = (res) => {
            this.imageUpdate.emit(reader.result.toString());
          }
        this.saveImgOffer(offerKeyToSet, file, true);
      }
    });
  }

  dataURLtoFile(dataurl, filename) {

    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  openDialogImportImage(offer: FullOffer) {
    const dialogRef = this.dialog.open(OpenDialogImportImageComponent, {
      data: {},
      height: '250px',
      width: '400px'
    });

    dialogRef.afterClosed().subscribe({
      next: (res) => {
        if (res) {
          reader.readAsDataURL(res),
            reader.onload = (res) => {
              this.imageUpdate.emit(reader.result.toString());
            }

          this.saveImgOffer(offer.offerKey, res, true);
        }
      }
    });
  }

  private saveImgOffer(offerKey: number, file: any, isMainPicture?: boolean): void {
    this.offerService.uploadImg(offerKey, [file], isMainPicture ? true : false).subscribe({
      next: () => {
      }
    });
  }



  private applyFilter(filterValue): void {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
